import { useOnboardingStore } from './onboardingStore.js';
import { isIos } from '../../lib/platform.js';
import { msg } from '../../lib/messages.js';
import './onboarding.css';

/** "Klargjør enheten for båtbruk" guide (Phase 2), platform-specific. */
export function SetupGuide(): JSX.Element | null {
  const show = useOnboardingStore((s) => s.showSetup);
  const close = useOnboardingStore((s) => s.closeSetup);
  if (!show) return null;

  const ios = isIos();

  return (
    <div className="onboard-backdrop" onClick={close}>
      <div className="onboard onboard--guide" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <h1 className="onboard__title numeral">{msg.setup.title}</h1>
        <p className="onboard__body">{msg.setup.intro}</p>

        <div className="onboard__step">
          <h2>{ios ? msg.setup.iosTitle : msg.setup.androidTitle}</h2>
          <p>{ios ? msg.setup.iosBody : msg.setup.androidBody}</p>
        </div>
        <div className="onboard__step">
          <h2>{msg.setup.powerTitle}</h2>
          <p>{msg.setup.powerBody}</p>
        </div>

        <button type="button" className="btn btn--accent onboard__ok" onClick={close}>
          {msg.setup.ok}
        </button>
      </div>
    </div>
  );
}
